module.exports = __webpack_public_path__ + "img/g1.1766d0e3.png";